import { appPaths } from "../../../shared/routing/appPaths";
import { WorkspaceLink } from "../../../shell/workspace";
import { useTermName } from "../../ontology/terms/termNames";

/**
 * A term a statement uses, by its label in the data model at the version the data was written
 * against (F94); it opens the term on the Data model beside, at that version (F75). Without
 * that version the name stays plain text.
 */
export default function TermLink({ iri, commit }: { iri: string; commit: string | null }) {
  const name = useTermName(iri, commit);
  if (commit === null) return <span title={iri}>{name}</span>;
  return (
    <WorkspaceLink route={appPaths.ontology({ version: commit, termIri: iri })} placement="beside" className="app-link" title={iri}>
      {name}
    </WorkspaceLink>
  );
}
